/* ODAVIA sticky add-to-cart - original code. Zeigt nur den aktuellen Preis; Vorschaubild und Variantenname folgen der gewählten Variante.
   Sichtbar nur, wenn der Haupt-Warenkorb-Button nach oben aus dem Bild gescrollt ist UND der Footer nicht im Bild ist
   (damit z. B. "Vertrag widerrufen" im Footer nie verdeckt wird). Solange sichtbar, bekommt der Footer unten zusätzlichen Platz. */
(function(){
  if (customElements.get('odavia-sticky-atc')) return;
  var ROOT_CLASS = 'odavia-satc-shown';
  class OdaviaStickyAtc extends HTMLElement {
    connectedCallback(){
      this.sectionId = this.dataset.section;
      this.mainBtn = document.getElementById('ProductSubmitButton-' + this.sectionId);
      this.btn = this.querySelector('.odavia-satc__btn');
      this.priceEl = this.querySelector('[data-satc-price]');
      this.metaEl = this.querySelector('[data-satc-variant]');
      this.shortLabel = (this.btn && this.btn.getAttribute('data-satc-label')) || '';
      this._observers = [];
      this._pastMain = false;
      this._footerVisible = {};
      var target = this.mainBtn ? (this.mainBtn.closest('.product-form__buttons') || this.mainBtn) : null;
      if (!target || !this.btn) return;
      var self = this;

      // 1) Haupt-Button: Balken erst zeigen, wenn er oben aus dem Bild gescrollt ist
      this.io = new IntersectionObserver(function(entries){
        var e = entries[entries.length - 1];
        self._pastMain = !e.isIntersecting && e.boundingClientRect.top < 0;
        self._update();
      }, { threshold: 0 });
      this.io.observe(target);

      // 2) Footer-Bereich (Section-Gruppe mit dem <footer>): Balken ausblenden, solange er im Bild ist
      var footers = [];
      document.querySelectorAll('.shopify-section-group-footer-group').forEach(function(sec){
        if (sec.querySelector('footer')) footers.push(sec);
      });
      if (!footers.length) {
        var f = document.querySelector('footer.footer') || document.querySelector('footer');
        if (f) footers.push(f.closest('.shopify-section') || f);
      }
      if (footers.length) {
        this.fio = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            var key = en.target.id || 'footer';
            self._footerVisible[key] = en.isIntersecting;
          });
          self._update();
        }, { threshold: 0 });
        footers.forEach(function(el){ self.fio.observe(el); });
      }

      this._onResize = function(){ self._syncHeight(); };
      window.addEventListener('resize', this._onResize, { passive: true });

      this._onBtnClick = function(){ if (self.mainBtn) self.mainBtn.click(); };
      this.btn.addEventListener('click', this._onBtnClick);

      var mainPrice = document.getElementById('price-' + this.sectionId);
      if (mainPrice && this.priceEl) {
        var syncPrice = function(){
          var el = mainPrice.querySelector('.price__sale .price-item--sale') || mainPrice.querySelector('.price-item--regular');
          if (el) self.priceEl.textContent = el.textContent.trim();
        };
        syncPrice();
        var po = new MutationObserver(syncPrice);
        po.observe(mainPrice, { childList: true, subtree: true, characterData: true });
        this._observers.push(po);
      }

      // Button-Zustand spiegeln. Beschriftung: kurzes "In den Warenkorb" – nur bei deaktiviertem
      // Haupt-Button (z. B. "Ausverkauft") dessen Text übernehmen.
      var syncBtn = function(){
        var dis = self.mainBtn.hasAttribute('disabled');
        self.btn.toggleAttribute('disabled', dis);
        var label = self.mainBtn.querySelector('span');
        var mine = self.btn.querySelector('span');
        if (!mine) return;
        var txt = dis && label && label.textContent.trim() ? label.textContent.trim() : (self.shortLabel || (label ? label.textContent.trim() : ''));
        if (txt && mine.textContent !== txt) mine.textContent = txt;
      };
      syncBtn();
      var bo = new MutationObserver(syncBtn);
      bo.observe(this.mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      this._observers.push(bo);

      // Variantenwechsel (Dawn pub/sub): Bild + Variantenname aus den Event-Daten übernehmen
      var img = this.querySelector('[data-satc-img]');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, function(e){
          var d = e && e.data;
          if (!d) return;
          if (d.sectionId && self.sectionId && d.sectionId !== self.sectionId) return;
          var v = d.variant;
          var m = v && v.featured_media;
          if (img && m && m.preview_image && m.preview_image.src) {
            var src = m.preview_image.src;
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            img.alt = m.alt || '';
          }
          self._setVariantLabel(v && v.title && v.title !== 'Default Title' ? v.title : self._labelFromDom());
        });
      }
    }
    // Fallback (z. B. nicht existierende Kombination, variant = null): aktuelle Auswahl frisch aus dem DOM lesen
    _labelFromDom(){
      var vs = document.querySelector('variant-selects[data-section="' + this.sectionId + '"]');
      if (!vs) return '';
      var parts = [];
      vs.querySelectorAll('select').forEach(function(s){
        if (s.selectedOptions[0]) parts.push(s.selectedOptions[0].textContent.trim());
      });
      vs.querySelectorAll('input[type="radio"]:checked').forEach(function(r){ parts.push(r.value); });
      return parts.filter(Boolean).join(' / ');
    }
    _setVariantLabel(txt){
      if (!this.metaEl) return;
      txt = txt || '';
      this.metaEl.textContent = txt;
      this.metaEl.hidden = !txt;
    }
    _syncHeight(){
      var h = this.offsetHeight;
      if (h) document.documentElement.style.setProperty('--odavia-satc-h', h + 'px');
    }
    _update(){
      var footerIn = false;
      for (var k in this._footerVisible) { if (this._footerVisible[k]) { footerIn = true; break; } }
      var show = this._pastMain && !footerIn;
      if (show) this._syncHeight();
      this.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle(ROOT_CLASS, show);
    }
    disconnectedCallback(){
      if (this.io) this.io.disconnect();
      if (this.fio) this.fio.disconnect();
      if (this._observers) this._observers.forEach(function(o){ o.disconnect(); });
      this._observers = [];
      if (this.btn && this._onBtnClick) this.btn.removeEventListener('click', this._onBtnClick);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (typeof this._unsubVariant === 'function') this._unsubVariant();
      document.documentElement.classList.remove(ROOT_CLASS);
    }
  }
  customElements.define('odavia-sticky-atc', OdaviaStickyAtc);
})();
